var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Button, BusyButton } from "../..";
import { Dialog, DialogContent, DialogActions } from '..';
import { TextOrNode } from "../../Text";
/**
 * This is a Dialog that should be used whenever you are performing a destructive action that
 * needs user confirmation.
 */
export var ConfirmDialog = function (_a) {
    var onClose = _a.onClose, onCancel = _a.onCancel, onConfirm = _a.onConfirm, _b = _a.children, children = _b === void 0 ? 'Are you sure you want to do that?' : _b, props = __rest(_a, ["onClose", "onCancel", "onConfirm", "children"]);
    return (React.createElement(Dialog, __assign({ closeOnEscPress: true, onClose: onClose }, props, { lss: __assign({ minWidth: 'xs' }, props.lss) }),
        React.createElement(DialogContent, { lss: {
                alignItems: 'center',
                justifyContent: 'center'
            } },
            React.createElement(TextOrNode, null, children)),
        React.createElement(DialogActions, null,
            React.createElement(BusyButton.Async, { scale: "sm", onClick: onConfirm, lss: {
                    width: 80,
                    minWidth: 0,
                    mx: 'sm'
                } }, "Yes"),
            React.createElement(Button, { scale: "sm", palette: "primary", emphasis: "medium", onClick: onCancel || onClose, lss: {
                    width: 80,
                    mx: 'sm'
                } }, "Cancel"))));
};
//# sourceMappingURL=ConfirmDialog.js.map